var get = require("object-path").get;

module.exports = {

    /**
     * The form factors.
     *
     * @public
     */
    formFactors: {
        default: [{
            width:       1920,
            height:      640,
            aspectRatio: 1920 / 640
        }, {
            width:       1280,
            height:      640,
            aspectRatio: 1280 / 640
        }, {
            width:       960,
            height:      640,
            aspectRatio: 960 / 640
        }, {
            width:       640,
            height:      640,
            aspectRatio: 640 / 640
        }],
        tall: [{
            width:       1280,
            height:      1280,
            aspectRatio: 1280 / 1280
        }, {
            width:       1920,
            height:      1080,
            aspectRatio: 1920 / 1080
        }]
    },

    /**
     * Get the width of the slide for a specific form-factor.
     *
     * @param  {string}  formFactor  The form-factor
     * @return {number}  The width
     * @public
     */
    getWidth: function(formFactor) {
        return get(this.formFactors, formFactor + ".width", 1);
    },

    /**
     * Get the height of the slide for a specific form-factor.
     *
     * @param  {string}  formFactor  The form-factor
     * @return {number}  The height
     * @public
     */
    getHeight: function(formFactor) {
        return get(this.formFactors, formFactor + ".height", 1);
    },

    /**
     * Get the aspect ratio of the slide for a specific form-factor.
     *
     * @param  {string}  formFactor  The form-factor
     * @return {number}  The aspect ratio
     * @public
     */
    getAspectRatio: function(formFactor) {
        return get(this.formFactors, formFactor + ".aspectRatio", 1);
    }

};
